import { GridRenderCellParams } from '@mui/x-data-grid';

import { CloudDisplay } from 'shared/base';

export const CloudColumn = ({ value }: GridRenderCellParams<any, string>) => {
  if (!value) {
    return null;
  }

  return <CloudDisplay value={value} />;
};
